import { computed, watchEffect, onUnmounted, toValue } from '#imports';
import type { MaybeRefOrGetter } from 'vue';
import { useAppStore } from '@nuxt-shared/composables/stores/useAppStore.js';
import { buildDisclaimerHtml } from '@nuxt-shared/lib/utils/disclaimer';
import type { DisclaimerAgreement } from '@nuxt-shared/lib/utils/disclaimer';

/**
 * Прокидывает дисклеймер текущей страницы в appStore, чтобы он отрисовался
 * в начале футера (см. widgets/footer/ui/Container.vue). Футер рендерится в
 * лейауте вне страницы, поэтому передача через стор — единственный канал.
 *
 * Значение очищается при размонтировании, чтобы дисклеймер не «протёк» на
 * страницы без него.
 *
 * @param agreement Элемент свойства AGREEMENT (ref/getter/значение)
 */
export function useFooterDisclaimer(
  agreement: MaybeRefOrGetter<DisclaimerAgreement | null | undefined>,
): void {
  const appStore = useAppStore();
  const disclaimerHtml = computed(() => buildDisclaimerHtml(toValue(agreement)));

  watchEffect(() => appStore.setPageDisclaimer(disclaimerHtml.value));
  onUnmounted(() => appStore.setPageDisclaimer(''));
}
